import { SpriteConstant } from 'src/app/constant/sprite.constant';
import { Component } from '@angular/core';
import { ComingSoonLayoutComponent } from '../core/comingsoon.layout.component';

@Component({
    selector: 'app-comingsoonlayoutmobile',
    templateUrl: './comingsoon.layout.mobile.component.html',
    styleUrls: ['../css/comingsoon.layout.mobile.component.scss'],
    standalone: false
})
export class ComingSoonLayoutMobileComponent extends ComingSoonLayoutComponent {
  constructor() {
    super();
  }

  onClick = (evt) => {
    this.eventEmit.emit('coming_soon_click');
  };
}
